"use strict";

/*
*
*   IMAGE UPLOADER
*
*/

// Class definition
var KTUpoaderAvatar = function () {
	// Elements
	var avatar;

	var _initForm = function() {
    avatar = new KTImageInput('kt_profile_avatar');

    // jQuery('#avatar_file').fileupload({
    //   dataType: 'json',
    //   add: function (e, data) {
    //     $('#progress').css('display','block');
    //     $('form#profile-form button[type="submit"]').attr('disabled',true)
    //     data.submit();
    //   },
    //   done: function (e, data) {
    //     var resp = data.result;
    //     //console.log({resp});
    //     jQuery('input#input_avatar').val(resp.id);
    //     $('#progress').html('<i class="fas fa-check text-success mr-5"></i> <span class="text">Archivo subido correctamente</span>');
    //     $('form#profile-form button[type="submit"]').attr('disabled',false)
    //   },
    //   error: function(e, c, d) {
    //     console.log("=======")
    //     console.log(e)
    //     console.log("=======")
    //     console.log(c)
    //     console.log("=======")
    //     console.log(d)
    //     console.log("=======")
    //   }
    // });
    // avatar.on('cancel', function(imageInput) {
		// 	// swal.fire({
    //   //           title: 'Image successfully canceled !',
    //   //           type: 'success',
    //   //           buttonsStyling: false,
    //   //           confirmButtonText: 'Awesome!',
    //   //           confirmButtonClass: 'btn btn-primary font-weight-bold'
    //   //       });
		// });

		// avatar.on('change', function(imageInput) {
		// 	swal.fire({
    //             title: 'Image successfully changed !',
    //             type: 'success',
    //             buttonsStyling: false,
    //             confirmButtonText: 'Awesome!',
    //             confirmButtonClass: 'btn btn-primary font-weight-bold'
    //         });
		// });
	}

	return {
		// public functions
		init: function() {
			_initForm();
		}
	};
}();

jQuery(document).ready(function() {
  KTUpoaderAvatar.init();
});
